import {
  AfterContentChecked,
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {UserService} from '../shared/services/user.service';
import {MenuService} from './menu/menu.service';
import {ConfigApiService} from '../../../projects/api/src/config/config-api.service';
import _ from 'lodash';
import {Router} from '@angular/router';
import {AuthService} from '../shared/services/auth.service';
import {ConfigureService} from '../../../projects/common/modules/configure/configure.service';
import {MainTempService} from './main-temp.service';

@Component({
    selector: 'app-main-temp',
    templateUrl: './main-temp.component.html',
    styleUrls: ['./main-temp.component.scss'],
    standalone: false
})
export class MainTempComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked  {
  @ViewChild('headerWrapperEl', { static: false }) headerWrapperEl: ElementRef;

  public hotKey = [];
  public headerWrapperHeight = 56;

  @HostListener('window:keydown', ['$event'])
  onKeydown = _.throttle((event) => {
    this.hotKey.push(event.keyCode);
    const ret = this.checkHotKey();
    if (ret) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  }, 100);

  @HostListener('window:keyup', ['$event'])
  onKeyup = _.throttle((event) => {
    this.hotKey = [];
  }, 100);

  /*
    @HostListener('window:beforeunload', ['$event'])
    onBeforeunload = _.throttle((event) => {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }, 10);*/

  private notificationMessage;
  private acceptMessage;

  private resizeObserver: ResizeObserver;

  constructor(private userService: UserService,
              private menuService: MenuService,
              private router: Router,
              private cdRef: ChangeDetectorRef,
              private authService: AuthService,
              private configApiService: ConfigApiService,
              private configService: ConfigureService,
              // private headerWrapperEl: ElementRef,
              private renderer: Renderer2,
              private MainTempService: MainTempService
  ) {
    // if (this.configService.options.appConfig.typeOfDefaultUrl === 'static' && this.configService.options.appConfig.defaultUrl) {
      // this.router.navigate([this.configService.options.appConfig.defaultUrl]);
    // }
  }

  checkHotKey(): boolean {
    if (this.hotKey && this.hotKey.length === 2) {
     /* if (this.hotKey[0] === 17 && this.hotKey[1] === 79) {//Ctrl O -
        this.router.navigate([ "/main", "page", "object" ]);
        return true;
      }

      if (this.hotKey[0] === 16 && this.hotKey[1] === 79) {//Ctrl O -  (+)
        this.router.navigate([ "/main", "page", "object" ]);
        return true;
      }

//-------------------------------------------------------------------------------------
      if (this.hotKey[0] === 17 && this.hotKey[1] === 69) {//Ctrl E +/-
        this.router.navigate([ "/main", 'eventslog' ]);
        return true;
      }
      if (this.hotKey[0] === 16 && this.hotKey[1] === 71) {//Ctrl G - (+)
        this.router.navigate([ "/main", "page", 'charts' ]);
        return true;
      }*/
      if (this.hotKey[0] === 17 && this.hotKey[1] === 77) { // Ctrl M +
        this.menuService.isCollapsed.next(false);
        // this.router.navigate([ "/main",  'map' ]);
        return true;
      }
// -------------------------------------------------------------------------------------
/*
      if (this.hotKey[0] === 17 && this.hotKey[1] === 82) {//Ctrl R +
        this.router.navigate([ "/main", "page", "reports" ]);
        return true;
      }
      if (this.hotKey[0] === 16 && this.hotKey[1] === 65) {//Ctrl A -
        this.router.navigate([ "/main", "page", "analitics",'dashboards' ]);
        return true;
      }
      if (this.hotKey[0] === 17 && this.hotKey[1] === 66) {//Ctrl B +
        this.router.navigate([ "/main", "page", "businessparams" ]);
        return true;
      }
      if (this.hotKey[0] === 16 && this.hotKey[1] === 74) {//Ctrl J -
        this.router.navigate([ "/main", "page", "businessevents" ]);
        return true;
      }
//-------------------------------------------------------------------------------------
      if (this.hotKey[0] === 16 && this.hotKey[1] === 84) {//Ctrl T -
        this.router.navigate([ "/main", "page", "typicalconfig" ]);
        return true;
      }
      if (this.hotKey[0] === 16 && this.hotKey[1] === 80) {//Ctrl P -
        this.router.navigate([ "/main", "page", "controlprocedure" ]);
        return true;
      }
      if (this.hotKey[0] === 16 && this.hotKey[1] === 72) {//Ctrl H -
        this.router.navigate([ "/main", "page", "paramstates" ]);
        return true;
      }
      if (this.hotKey[0] === 17 && this.hotKey[1] === 86) {//Ctrl V
        this.router.navigate([ "/main", "page", "event" ]);
        return true;
      }
      if (this.hotKey[0] === 17 && this.hotKey[1] === 83) {//Ctrl S
        this.router.navigate([ "/main", "page", "scheduletemplate" ]);
        return true;
      }
      if (this.hotKey[0] === 17 && this.hotKey[1] === 90) {//Ctrl Z +
        this.router.navigate([ "/main", "page", "zone" ]);
        return true;
      }
      if (this.hotKey[0] === 17 && this.hotKey[1] === 88) {//Ctrl X +
        this.router.navigate([ "/main", "geo", "geozones" ]);
        return true;
      }



//-------------------------------------------------------------------------------------
      if (this.hotKey[0] === 17 && this.hotKey[1] === 89) {//Ctrl Y
        this.router.navigate([ "/main", "page", "device" ]);
        return true;
      }
      if (this.hotKey[0] === 16 && this.hotKey[1] === 87) {//Ctrl w Dashboard
        this.router.navigate([ "/main", "dashboard" ]);
        return true;
      }
      if (this.hotKey[0] === 17 && this.hotKey[1] === 81) {//Ctrl Q Dashboard
        this.authService.logout();
        return true;
      }
*/
    }
    return false;
//     this.cdr.detectChanges();
  }


  // theme = userService.theme;

  // getThemeName = () => {
  //   return userService.theme
  // };

  isLoginPage() {
    return false;
    // return $state.current.name === 'auth.login'
  }

  ngAfterContentChecked() {
    this.headerWrapperHeight = this.headerWrapperEl?.nativeElement.offsetHeight;
    // this.cdRef.detectChanges();
  }

  isMenuCollapsed() {
    return this.menuService.isCollapsed;
  }

  menuToggle() {
    this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
  }

  ngOnInit() {
    this.configApiService.getAuth().subscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.headerWrapperHeight = this.headerWrapperEl.nativeElement.offsetHeight;

      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          this.headerWrapperHeight = entry.contentRect.height;
          this.MainTempService.set(this.headerWrapperHeight);
        }
      });

      this.resizeObserver.observe(this.headerWrapperEl.nativeElement);
    });
  }

  private disconnectResizeObserver() {
    this.resizeObserver.unobserve(this.headerWrapperEl.nativeElement);
    this.resizeObserver.disconnect();
  }

  ngOnDestroy(): void {
    this.disconnectResizeObserver();
  }

  gotNewMessage(event) {
    this.notificationMessage = event;
  }

  onAcceptMessage(event) {
    this.acceptMessage = event;
  }

  onNotificationToastHeight(event) {
    console.log(event);
  }
}
